// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Z3sthYeciYs65JqAC4jU{flex-direction:column;display:flex}.Z3sthYeciYs65JqAC4jU>:not(:last-child){margin-bottom:24px}.lH4hqNABjuc_3R3w48ww{margin-left:4px}.m6P996UpMzM9qoS_LpeR{align-items:center;gap:8px;display:flex}.DRMvsyTW4NoTbXy3bTVv{padding:8px 0}.DRMvsyTW4NoTbXy3bTVv .QstfZcyfn50bUxAv5aeS{flex-wrap:wrap;align-items:center;gap:8px;padding:0 8px 8px;display:flex;overflow-x:hidden;overflow-y:auto}.DRMvsyTW4NoTbXy3bTVv .HgUtRSKrJzAbRLDyrY58{padding:4px}.DRMvsyTW4NoTbXy3bTVv .FaRj6CW67UsyURkDuGsk{border-bottom:1px var(--interaction-neutral-normal)solid;width:100%}.DRMvsyTW4NoTbXy3bTVv .NYTPngcLWaI4pAmTFXrW{padding:4px 4px 0}.DRMvsyTW4NoTbXy3bTVv .OuMASW7Axho_9C6c1jVA{text-align:center;padding:8.5px}.YQsFDWqwz8kn4K6qk78q{height:40px;padding-right:8px!important}.LpoTEiURRDoiYy5wUmbB{padding:11px 12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Z3sthYeciYs65JqAC4jU`,
	"inboxNameInput": `lH4hqNABjuc_3R3w48ww`,
	"selectLine": `m6P996UpMzM9qoS_LpeR`,
	"dropdownContentWrap": `DRMvsyTW4NoTbXy3bTVv`,
	"selectedItemsWrap": `QstfZcyfn50bUxAv5aeS`,
	"search": `HgUtRSKrJzAbRLDyrY58`,
	"divider": `FaRj6CW67UsyURkDuGsk`,
	"searchItemsListWrap": `NYTPngcLWaI4pAmTFXrW`,
	"noResult": `OuMASW7Axho_9C6c1jVA`,
	"selectOwnerBtn": `YQsFDWqwz8kn4K6qk78q`,
	"selectMembersPadding": `LpoTEiURRDoiYy5wUmbB`
};
export default ___CSS_LOADER_EXPORT___;
